"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
var styled_components_1 = __importStar(require("styled-components"));
var charts_config_1 = __importStar(require("./charts-config"));
var charts_styled_1 = require("./charts.styled");
var locale_context_1 = __importDefault(require("../../context/locale/locale.context"));
var react_router_dom_1 = require("react-router-dom");
var use_translations_hook_1 = __importDefault(require("../../context/translations/use-translations.hook"));
var highcharts_1 = __importDefault(require("highcharts"));
var InnerContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var Charts = function (_a) {
    var series = _a.series, yAxisTitle = _a.yAxisTitle, callback = _a.callback, valueFormatter = _a.valueFormatter, timezoneOffset = _a.timezoneOffset, _b = _a.xAxisLabelFormat, xAxisLabelFormat = _b === void 0 ? 'default' : _b, toolTipLabelFormat = _a.toolTipLabelFormat, live = _a.live, liveQuery = _a.liveQuery, height = _a.height, width = _a.width, categories = _a.categories, _c = _a.allowDecimalsOnYAxis, allowDecimalsOnYAxis = _c === void 0 ? true : _c, _d = _a.tooltipSignificantDigits, tooltipSignificantDigits = _d === void 0 ? 2 : _d, startValueOnXAxis = _a.startValueOnXAxis, _e = _a.is12HourSystem, is12HourSystem = _e === void 0 ? false : _e;
    var theme = react_1.useContext(styled_components_1.ThemeContext);
    var locale = react_1.useContext(locale_context_1.default);
    var location = react_router_dom_1.useLocation();
    var getTranslation = use_translations_hook_1.default().getTranslation;
    var containerRef = react_1.useRef(null);
    var _f = react_1.useState(height || 0), appliedHeight = _f[0], setAppliedHeight = _f[1];
    var _g = react_1.useState(width || 0), appliedWidth = _g[0], setAppliedWidth = _g[1];
    react_1.useEffect(function () {
        return function () {
            var cancelEvent = new CustomEvent(charts_config_1.CancelLiveUpdate);
            document.dispatchEvent(cancelEvent);
        };
    }, [location.pathname]);
    react_1.useLayoutEffect(function () {
        if (!containerRef.current)
            return;
        var _a = containerRef.current.getBoundingClientRect(), elementHeight = _a.height, elementWidth = _a.width;
        if (height === undefined)
            setAppliedHeight(elementHeight);
        if (width === undefined)
            setAppliedWidth(elementWidth);
    }, [height, width]);
    var options = react_1.useMemo(function () {
        var options = charts_config_1.default({
            height: appliedHeight,
            width: appliedWidth,
            theme: theme,
            locale: locale,
            valueFormatter: valueFormatter,
            labelFormat: xAxisLabelFormat,
            toolTipLabelFormat: toolTipLabelFormat,
            timezoneOffset: timezoneOffset,
            live: live,
            liveQuery: liveQuery,
            categories: categories,
            allowDecimalsOnYAxis: allowDecimalsOnYAxis,
            tooltipSignificantDigits: tooltipSignificantDigits,
            startValueOnXAxis: startValueOnXAxis,
            is12HourSystem: is12HourSystem,
        }, getTranslation);
        options.series = series;
        return options;
    }, [
        series,
        theme,
        locale,
        valueFormatter,
        timezoneOffset,
        xAxisLabelFormat,
        toolTipLabelFormat,
        live,
        liveQuery,
        appliedHeight,
        appliedWidth,
        getTranslation,
        categories,
        allowDecimalsOnYAxis,
        tooltipSignificantDigits,
        startValueOnXAxis,
        is12HourSystem,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InnerContainer, null,
            react_1.default.createElement(charts_styled_1.YAxisTitle, null, yAxisTitle),
            react_1.default.createElement(charts_styled_1.ChartsContainer, { ref: containerRef }, appliedHeight > 0 && appliedWidth > 0 && (react_1.default.createElement(highcharts_react_official_1.default, { highcharts: highcharts_1.default, options: options, callback: callback, immutable: true }))))));
};
Charts.displayName = 'Charts';
exports.default = react_1.default.memo(Charts);
var templateObject_1;
//# sourceMappingURL=charts.component.js.map